function CharCounter({ current, max }) {
  if (current === 0) return null;
  return (
    <span className={`char-counter ${current >= max ? 'char-counter--error' : ''}`}>
      {current}/{max}
    </span>
  );
}

export default CharCounter;
